<!--
 * @version: V1.0.0
 * @Date: 2023-08-14 16:25:54
 * @LastEditors: lzq
 * @LastEditTime: 2023-12-29 17:43:41
 * @company: 睿展数据
 * @FilePath: \udi-wms-client\src\views\traceability\components\detail.vue
 * @Descripttion:
-->
<!--  -->
<template>
  <el-drawer
    v-loading.fullscreen="loading"
    :visible="visible"
    size="65%"
    :append-to-body="true"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :destroy-on-close="true"
    :show-close="false"
    :wrapper-closable="false">
    <div slot="title" style="display: flex;justify-content:space-between;">
      <div>
        单据信息
      </div>
      <div>
        <el-button plain @click="$emit('close')"> 返回</el-button>
      </div>
    </div>
    <el-form class="orderInfo-form" label-suffix="： ">
      <template v-if="operationType==='YHCK'">
        <el-form-item label="发货日期">
          {{ orderInfo.specifyDeliveryDate ? parseTime(orderInfo.specifyDeliveryDate, '{y}-{m}-{d}') : '' }}
        </el-form-item>
        <el-form-item label="单据编号">
          {{ orderInfo.bizId }}
        </el-form-item>
        <el-form-item label="业务类型">
          <!-- {{ orderInfo.used }} -->
          <span v-if="['其他出库业务', '出库业务'].includes(orderInfo.used)">{{ orderInfo.used }}</span>
          <dict-tag v-else :options="dictObj.bizType" :value="orderInfo.qtType" />
        </el-form-item>
        <el-form-item label="申请部门">
          {{ orderInfo.applyOrgName }}
        </el-form-item>
        <el-form-item label="客户名称">
          {{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customer : null }}
        </el-form-item>
        <el-form-item label="收件人区域">
          {{ area }}

        </el-form-item>
        <el-form-item label="收件人详细地址">
          {{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerAddress : null }}
        </el-form-item>
        <el-form-item label="收件人电话">
          {{ orderInfo.recipientInfoVo ? orderInfo.recipientInfoVo.customerTelephone : null }}
        </el-form-item>
      </template>
      <template v-else>
        <el-form-item label="单据编号">
          {{ orderInfo.inCode }}
        </el-form-item>
        <el-form-item label="单据类型">
          <dict-tag  :options="dictObj.inType" :value="orderInfo.inType" />
        </el-form-item>
        <el-form-item label="申请部门">
          {{ orderInfo.applyOrgName }}
        </el-form-item>
        <el-form-item label="入库方式">
          <dict-tag  :options="dictObj.warehouseType" :value="orderInfo.inWay" />
        </el-form-item>
        <el-form-item label="生产组织">
          {{ orderInfo.workOrgName }}
        </el-form-item>
        <el-form-item label="生产车间">
          {{ orderInfo.workshop }}
        </el-form-item>
        <el-form-item label="订单编号">
          {{ orderInfo.bizName }}
        </el-form-item>
      </template>

    </el-form>
  </el-drawer>
</template>
<script>

import {getWarehousingOrderInfo} from "@/api/warehousingOrder";
import { getOrderInfo } from "@/api/orderManage";

export default {
  name: 'OrderInfo',
  props: {
    visible: {
      type: Boolean,
      default() {
        return false
      }
    },
    operationType: {
      type: String,
      default() {
        return ''
      }
    },
    dictObj: {
      type: Object,
      default() {
        return {
          warehouseType: [],
          inType: []
        }
      }
    },
    orderId: {
      type: String,
      default() {
        return ''
      }
    },
  },
  data() {
    // 这里存放数据
    return {
      loading: false,
      orderInfo:{}
    }
  },
  computed: {
    area() {
      const recipientInfoVo = this.orderInfo.recipientInfoVo;
      return `${recipientInfoVo.consigneeProvinceName || ''}${recipientInfoVo.consigneeCityName || ''}${recipientInfoVo.consigneeCountyName || ''}`
    }
  },
  created() {
    this.getOrderInfo(this.orderId)
  },
  // 方法集合
  methods: {
    // 获取单据信息
    getOrderInfo(orderId) {
      // 获取基础信息数据
      if (this.operationType === 'SCRK' || this.operationType === 'SMRK') {
        this.loading = true
        getWarehousingOrderInfo(orderId).then(res => {
          this.orderInfo = res.data
        }).finally(() => {
          this.loading = false
        })
      }
      if (this.operationType === 'YHCK') {
        this.loading = true
        getOrderInfo(orderId).then(res => {
          this.orderInfo = res.data
        }).finally(() => {
          this.loading = false
        })
      }

    },
  }
}
</script>
